export enum Permission {
  AiAgentExecute = 'ai_agent.execute',
}
